import { useCallback, useEffect, useState } from 'react';
export const useFilterString = (searchable, activeItem, onFilterStringChange) => {
  const [filterString, setFilterString] = useState();
  useEffect(() => {
    setFilterString(undefined);
  }, [activeItem]);
  const handleFilterStringChange = useCallback(filterString => {
    if (searchable) {
      setFilterString(filterString);
      onFilterStringChange?.(filterString ?? '');
    }
  }, [onFilterStringChange, searchable]);
  return {
    filterString,
    handleFilterStringChange
  };
};